<!-- dialog-edit-time-entry.component.html -->
<h2 mat-dialog-title>{{ data.title }}</h2>

<mat-dialog-content>
    <form [formGroup]="timeEntryForm">
        <div class="time-inputs">
            <!-- Time In Section -->
            <div class="datetime-group">
                <h6 class="group-label">Time In</h6>
                <div class="datetime-row">
                    <mat-form-field appearance="outline" class="date-field">
                        <mat-label>Date In</mat-label>
                        <input matInput type="date" formControlName="dateIn">
                        <mat-error *ngIf="timeEntryForm.get('dateIn')?.hasError('required')">
                            Date is required
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="time-field">
                        <mat-label>Time</mat-label>
                        <input matInput type="time" formControlName="timeIn" step="1">
                        <mat-error *ngIf="timeEntryForm.get('timeIn')?.hasError('required')">
                            Time is required
                        </mat-error>
                        <mat-error *ngIf="timeEntryForm.get('timeIn')?.hasError('invalidDateTimeRange')">
                            Invalid range
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <!-- Time Out Section -->
            <div class="datetime-group">
                <h6 class="group-label">Time Out</h6>
                <div class="datetime-row">
                    <mat-form-field appearance="outline" class="date-field">
                        <mat-label>Date Out</mat-label>
                        <input matInput type="date" formControlName="dateOut">
                        <mat-error *ngIf="timeEntryForm.get('dateOut')?.hasError('required')">
                            Date is required
                        </mat-error>
                        <mat-error *ngIf="timeEntryForm.get('dateOut')?.hasError('invalidDateTimeRange')">
                            Must be after Time In
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="time-field">
                        <mat-label>Time</mat-label>
                        <input matInput type="time" formControlName="timeOut" step="1">
                        <mat-error *ngIf="timeEntryForm.get('timeOut')?.hasError('required')">
                            Time is required
                        </mat-error>
                        <mat-error *ngIf="timeEntryForm.get('timeOut')?.hasError('invalidDateTimeRange')">
                            Must be after Time In
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </div>

        <!-- Optional: Display form validation summary -->
        <div *ngIf="timeEntryForm.invalid && timeEntryForm.touched" class="validation-summary">
            <mat-error>
                Please ensure Time Out is after Time In and all fields are filled.
            </mat-error>
        </div>
    </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()" [disabled]="isSaving">
        Cancel
    </button>
    <button mat-raised-button color="primary" [disabled]="!timeEntryForm.valid || isSaving" (click)="onSave()">
        <span *ngIf="!isSaving">{{ isNewEntry ? 'Add' : 'Save' }}</span>
        <span *ngIf="isSaving">
            <span class="spinner-border spinner-border-sm me-2"></span>
            {{ isNewEntry ? 'Adding...' : 'Saving...' }}
        </span>
    </button>
</mat-dialog-actions>